import { useEffect, useState } from "react";
import CommonModal from "./CommonModal";
import { bucketUrl, getFileType } from "../utils/helper";
import { Spinner } from "react-bootstrap";
import { requestWithToken } from "../utils/apis";
import MultipleDragDropImage from "./MultipleDragDropImage";
import cross from "../assets/black-cross.svg";

export default function MediaPickerModal({ show, onClose, onSelect }) {
    const [files, setFiles] = useState([]);
    const [loading, setLoading] = useState(false);

    // Fetch List
    const fetchFiles = async () => {
        setLoading(true);
        try {
            const result = await requestWithToken(
                "GET",
                `/api/media/list?page=1&limit=500&type=2`
            );
            if (result?.status === 200) {
                setFiles(result.data.data.list);
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (show) fetchFiles();
    }, [show]);

    return (
        <CommonModal show={show} onClose={onClose} width="60vw" height="60vh">
            <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>

                <div style={{ display: "flex", justifyContent:"space-between", fontSize: 20, fontWeight: 600, marginBottom: 10 }}>
                    Select Media or Upload New <img src={cross} alt="icon" className="pointer" onClick={onClose} />
                </div>
                <div style={{ flexShrink: 0 }}>
                    <MultipleDragDropImage
                        fetchMediaFiles={() => fetchFiles()}
                        type={2}    
                    />
                </div>

                {/* SCROLLABLE GRID */}
                <div className="mt-2" style={{ flexGrow: 1, overflowY: "auto", paddingRight: 6, height: "300px" }}>
                    {loading ? (
                        <div className="text-center py-4"><Spinner /></div>
                    ) : (
                        <div
                            style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(auto-fill, minmax(130px, 1fr))",
                                gap: "16px",
                                height: "300px",
                            }}
                        >
                            {files
                                .filter((f) => !f.url?.toLowerCase().endsWith(".json"))
                                .map((f) => {
                                const fileUrl = bucketUrl + f.url;
                                const isSvg = f.url?.toLowerCase().endsWith(".svg");
                                return (
                                    <div
                                        key={f._id}
                                        style={{
                                            height: "130px",
                                            borderRadius: "12px",
                                            overflow: "hidden",
                                            cursor: "pointer",
                                            border: "2px solid #e2e8f0",
                                            backgroundColor: "#f8f9fa",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            transition: "0.2s",
                                            padding: isSvg ? "8px" : "0",
                                        }}
                                        className="media-hover"
                                        onClick={() => {
                                            onSelect(fileUrl);
                                            onClose();
                                        }}
                                    >
                                        {getFileType(f.url) === "video" ? (
                                            <video
                                                src={fileUrl}
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover",
                                                }}
                                            />
                                        ) : (
                                            <img
                                                src={fileUrl}
                                                alt="media"
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: isSvg ? "contain" : "cover",
                                                }}
                                            />
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
            </div>

            <style>{`
                .media-hover:hover {
                    border-color: #000 !important;
                    transform: scale(1.02);
                }
            `}</style>
        </CommonModal>
    );
}
